import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
var _IconVideoCameraSolid, _IconVideoCameraOffLi;
// /*
//  * The MIT License (MIT)
//  *
//  * Copyright (c) 2015 - present Instructure, Inc.
//  *
//  * Permission is hereby granted, free of charge, to any person obtaining a copy
//  * of this software and associated documentation files (the "Software"), to deal
//  * in the Software without restriction, including without limitation the rights
//  * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
//  * copies of the Software, and to permit persons to whom the Software is
//  * furnished to do so, subject to the following conditions:
//  *
//  * The above copyright notice and this permission notice shall be included in all
//  * copies or substantial portions of the Software.
//  *
//  * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
//  * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
//  * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
//  * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
//  * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
//  * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
//  * SOFTWARE.
//  */
import React, { useCallback, useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { IconVideoCameraSolid, IconVideoCameraOffLine } from '@instructure/ui-icons';
import DeviceSelection, { OFF_VALUE } from '../DeviceSelection';
import * as CaptureActions from '../../../actions';
import { translate } from '../../../constants/translated/translations';

/**
---
private: true
---
**/
function VideoDeviceSelection({
  videoDeviceId,
  devices,
  actions,
  isDisabled,
  mobile
}) {
  const isButtonDisabled = isDisabled || devices.length === 0 || devices.every(device => device.deviceId === '');
  const handleDeviceSelect = useCallback(newSelectedDeviceId => {
    if (!newSelectedDeviceId) return;
    if (newSelectedDeviceId === OFF_VALUE) {
      actions.videoDeviceDisabled();
      return;
    }
    actions.videoDeviceChanged(newSelectedDeviceId);
  }, [actions]);
  const devicesWithFixedLabels = useMemo(() => {
    return devices.map((device, index) => {
      const deviceInfo = device.toJSON();
      return _objectSpread(_objectSpread({}, deviceInfo), {}, {
        label: deviceInfo.label ? deviceInfo.label : `${translate('CAMERA')} ${index + 1}`
      });
    });
  }, [devices]);
  return /*#__PURE__*/React.createElement(DeviceSelection, {
    selectedDeviceId: videoDeviceId,
    devices: devicesWithFixedLabels,
    onDeviceSelected: handleDeviceSelect,
    onSubsectionSelected: actions.toggleCameraEffect,
    label: translate('WEBCAM_VIDEO_SELECTION_LABEL'),
    icon: videoDeviceId ? _IconVideoCameraSolid || (_IconVideoCameraSolid = /*#__PURE__*/React.createElement(IconVideoCameraSolid, null)) : _IconVideoCameraOffLi || (_IconVideoCameraOffLi = /*#__PURE__*/React.createElement(IconVideoCameraOffLine, null)),
    offLabel: translate('WEBCAM_DISABLED'),
    isDisabled: isButtonDisabled,
    "data-testid": "VideoDeviceSelection",
    color: "primary-inverse",
    mobile: mobile
  });
}
const mapStateToProps = state => ({
  videoDeviceId: state.videoDeviceId,
  devices: state.devices.videoinput
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(CaptureActions, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(VideoDeviceSelection);